export default {
  UltimateAdmin: 'UltimateAdministrator',
  CompanyAnnouncer: 'CompanyAnnouncer',
  DepartmentAnnouncer: 'DepartmentAnnouncer',
  BannerAdmin: 'BannerAdministrator',
  PolicyAdmin: 'PolicyAdministrator',
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/configs/role.js
 **/